import api from "./Api";

class CompraItemRelacionamentoFornecedorService {
  DeleteCompraItemRelacionamentoFornecedor(payload) {
    return api
      .delete("/v1/CompraItemRelacionamentoFornecedor/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetCompraItemRelacionamentoFornecedorOData(payload) {
    return api
      .get("/OData/compraItemRelacionamentoFornecedor" + payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new CompraItemRelacionamentoFornecedorService();
